import type { ClassifiedError } from './errors'
import type { FeedbackCategory } from '@/types'

export interface FeedbackContext {
  error?: ClassifiedError
  category?: FeedbackCategory
  /** Screen as it was before the dialog opened (rage shake); may still be rendering. */
  screenshot?: Promise<Blob | null>
  entryPoint?: 'form' | 'shake'
}

let handler: ((ctx?: FeedbackContext) => void) | null = null

export function openFeedback(ctx?: FeedbackContext) {
  handler?.(ctx)
}

export function registerFeedbackHandler(h: (ctx?: FeedbackContext) => void) {
  handler = h
  return () => {
    handler = null
  }
}
